import Cookies from 'js-cookie';

export function logOut(){
    localStorage.removeItem('loginUserId');
    localStorage.removeItem('loginUserName');
    localStorage.removeItem('access_token');
    Cookies.remove('userId');
}